import "./App.css";
import { AnimatePresence } from "framer-motion";
import { Routes, Route, NavLink } from "react-router";
import Wrapper from "./hooks/wrapper.js";

import About from "./components/about.js";
import Designs from "./components/designs";
import Videos from "./components/videos";
import Contact from "./components/contact";

import { TfiMenu } from "react-icons/tfi";

function MobileMenu() {
  window.onload = function () {
    const MobileToggle = document.getElementById("MobileToggle");
    const MobileHeader = document.querySelector(".MobileHeader");
    MobileToggle.addEventListener("click", function () {
      MobileHeader.classList.toggle("open");
    });
    const CloseMenu = document.querySelector(".CloseMenu");
    CloseMenu.addEventListener("click", function () {
      MobileHeader.classList.remove("open");
    });
    const MobileNav = document.querySelectorAll(".MobileNav");
    MobileNav.forEach((n) => {
      n.addEventListener("click", function () {
        MobileHeader.classList.remove("open");
      });
    });
  };

  return (
    <div>
      <div className="MobileHeader">
        <ul>
          <li>
            <NavLink to="/about" className="MobileNav">
              ABOUT
            </NavLink>
          </li>
          <li>
            <NavLink to="/design/2d" className="MobileNav">
              2D DESIGN
            </NavLink>
          </li>
          <li>
            <NavLink to="/design/3d" className="MobileNav">
              3D DESIGN
            </NavLink>
          </li>
          <li>
            <NavLink to="/design/product" className="MobileNav">
              PRODUCTION DESIGN
            </NavLink>
          </li>
          <li>
            <NavLink to="/videos" className="MobileNav">
              VIDEOS
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" className="MobileNav">
              CONTACT
            </NavLink>
          </li>
          <li>
            <a
              href="https://portfolio.gyeong.net/"
              target="_blank"
              rel="noreferrer"
            >
              LEGACY WEB
            </a>
          </li>
          <button className="CloseMenu">✖</button>
        </ul>
      </div>
      <div id="MobileToggle">
        <TfiMenu />
      </div>
    </div>
  );
}

function Main() {
  return (
    <Wrapper>
      <div className="Main">
        <div className="PCHeader">
          <ul>
            <li>
              <NavLink to="/about">ABOUT</NavLink>
            </li>
            <li>
              <NavLink to="/design/2d">2D DESIGN</NavLink>
            </li>
            <li>
              <NavLink to="/design/3d">3D DESIGN</NavLink>
            </li>
            <li>
              <NavLink to="/design/product">PRODUCT DESIGN</NavLink>
            </li>
            <li>
              <NavLink to="/videos">VIDEOS</NavLink>
            </li>
            <li>
              <NavLink to="/contact">CONTACT</NavLink>
            </li>
            <li>
              <a
                href="https://portfolio.gyeong.net/"
                target="_blank"
                rel="noreferrer"
              >
                LEGACY WEB
              </a>
            </li>
          </ul>
        </div>

        <div className="MainLogo">
          <a
            href="https://gyeong.net/"
            target="_blank"
            rel="noreferrer"
            title="https://gyeong.net/ 으로 이동합니다."
          >
            <div className="img" />
          </a>
        </div>
      </div>

      <div className="caption bottomRight">
        WEB PORTFOLIO
        <br />
        LAST UPDATE: 2026-05-31
      </div>
    </Wrapper>
  );
}

function Footer() {
  var now = new Date();
  var year = now.getFullYear();
  return (
    <div className="caption bottomLeft">
      &copy; 2019. 敬 경.
      <br />
      &copy; 2020-{year} GYEONG Studio / GYEONG.
      <br />
      All rights reserved.
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <MobileMenu />
      <AnimatePresence>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/about" element={<About />} />
          <Route path="/design/:categories" element={<Designs />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </AnimatePresence>
      <Footer />
    </div>
  );
}

export default App;
